export type DocumentTransactionMatchingJson = {
  id: number;
  document: { id: number };
  bank_transaction: { id: number };
  invalid_matching: boolean;
  matching_type: string;
};

export class DocumentTransactionMatching {
  constructor(
    public id: number,
    public documentId: number,
    public transactionId: number,
    public invalidMatching: boolean,
    public matchingType: string
  ) {}

  static fromJson(json: DocumentTransactionMatchingJson): DocumentTransactionMatching {
    return new DocumentTransactionMatching(
      json.id,
      json.document.id,
      json.bank_transaction.id,
      json.invalid_matching,
      json.matching_type
    );
  }
}
